/* src/app/front-layout/home/home.component.css */
.sh-page {
  --sh-p: #0B4F6C;
  --sh-s: #01BAEF;
  --sh-g: #F5A623;
  --sh-d: #06253A;
  --sh-li: #EBF7FB;
  --sh-bo: #CBECF4;
  --sh-mu: #6B8FA0;
  --sh-bg: #F4F8FA;
  --sh-surf: #FFFFFF;
  --sh-tx: #1E3A4A;
  --sh-tl: #4A6477;
  font-family:
    "Nunito",
    "Segoe UI",
    sans-serif;
  color: var(--sh-tx);
  background: var(--sh-bg);
  box-sizing: border-box;
  overflow-x: hidden;
}
.sh-page * {
  box-sizing: border-box;
}
.sh-container {
  max-width: 1280px !important;
  width: 100% !important;
  margin-left: auto !important;
  margin-right: auto !important;
  padding-left: 48px !important;
  padding-right: 48px !important;
  float: none !important;
}
.sh-eyebrow {
  font-size: 11px !important;
  font-weight: 800 !important;
  letter-spacing: .14em;
  text-transform: uppercase;
  color: var(--sh-s) !important;
  display: flex !important;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.sh-eyebrow::before,
.sh-eyebrow::after {
  content: "";
  height: 2px;
  width: 18px;
  background: var(--sh-s);
  border-radius: 2px;
  display: block;
  flex-shrink: 0;
}
.sh-eyebrow--light {
  color: rgba(255, 255, 255, .7) !important;
}
.sh-eyebrow--light::before,
.sh-eyebrow--light::after {
  background: rgba(255, 255, 255, .5);
}
.sh-section-title {
  font-size: clamp(24px, 3.2vw, 36px) !important;
  font-weight: 900 !important;
  color: var(--sh-d) !important;
  line-height: 1.2 !important;
  letter-spacing: -.4px;
}
.sh-section-title span {
  color: var(--sh-s) !important;
}
.sh-section-title--light {
  color: #fff !important;
}
.sh-section-title--light span {
  color: var(--sh-g) !important;
}
.sh-btn-gold {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  background: var(--sh-g) !important;
  color: var(--sh-d) !important;
  border: none !important;
  border-radius: 100px !important;
  padding: 13px 28px !important;
  font-size: 15px !important;
  font-weight: 800 !important;
  cursor: pointer;
  font-family: inherit;
  transition: transform .2s, box-shadow .2s;
  text-decoration: none !important;
}
.sh-btn-gold:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(245, 166, 35, .35) !important;
}
.sh-btn-navy {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  background: var(--sh-p) !important;
  color: #fff !important;
  border: none !important;
  border-radius: 100px !important;
  padding: 13px 28px !important;
  font-size: 15px !important;
  font-weight: 800 !important;
  cursor: pointer;
  font-family: inherit;
  transition: background .2s, transform .2s;
  text-decoration: none !important;
}
.sh-btn-navy:hover {
  background: var(--sh-s) !important;
  transform: translateY(-2px);
}
.sh-btn-outline {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, .1) !important;
  color: rgba(255, 255, 255, .9) !important;
  border: 1.5px solid rgba(255, 255, 255, .3) !important;
  border-radius: 100px !important;
  padding: 11px 24px !important;
  font-size: 15px !important;
  font-weight: 700 !important;
  cursor: pointer;
  font-family: inherit;
  transition: background .2s;
  text-decoration: none !important;
}
.sh-btn-outline:hover {
  background: rgba(255, 255, 255, .18) !important;
}
.sh-hero {
  background:
    linear-gradient(
      135deg,
      #04111a 0%,
      var(--sh-d) 55%,
      #0a6070 100%) !important;
  min-height: 80vh;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding: 80px 0 60px !important;
  width: 100% !important;
}
.sh-hero-blob {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}
.sh-hero-blob--1 {
  width: 600px;
  height: 600px;
  background:
    radial-gradient(
      circle,
      rgba(1, 186, 239, .07) 0%,
      transparent 70%);
  top: -200px;
  right: -150px;
}
.sh-hero-blob--2 {
  width: 350px;
  height: 350px;
  background:
    radial-gradient(
      circle,
      rgba(245, 166, 35, .06) 0%,
      transparent 70%);
  bottom: -100px;
  left: -60px;
}
.sh-hero-inner {
  display: flex !important;
  align-items: center;
  gap: 56px;
  position: relative;
  z-index: 1;
  width: 100% !important;
}
.sh-hero-left {
  flex: 1;
  min-width: 0;
  margin-top: 25px;
}
.sh-hero-eyebrow {
  display: inline-flex !important;
  align-items: center;
  gap: 7px;
  font-size: 11px !important;
  font-weight: 800 !important;
  letter-spacing: .14em;
  text-transform: uppercase;
  color: var(--sh-s) !important;
  margin-bottom: 18px;
  background: rgba(1, 186, 239, .1);
  border: 1px solid rgba(1, 186, 239, .2);
  padding: 6px 14px;
  border-radius: 100px;
}
.sh-hero-title {
  font-size: clamp(30px, 4.5vw, 54px) !important;
  font-weight: 900 !important;
  color: #fff !important;
  line-height: 1.1 !important;
  letter-spacing: -1px;
  margin-bottom: 18px !important;
}
.sh-hero-title span,
.sh-hero-title em {
  color: var(--sh-s) !important;
  font-style: normal;
}
.sh-hero-desc {
  font-size: 16px !important;
  color: rgba(255, 255, 255, .7) !important;
  line-height: 1.8 !important;
  margin-bottom: 32px !important;
  max-width: 500px;
}
.sh-hero-actions {
  display: flex !important;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 36px;
}
.sh-slider-ctrl {
  display: flex !important;
  align-items: center;
  gap: 12px;
}
.sh-sarr {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, .08) !important;
  border: 1.5px solid rgba(255, 255, 255, .2) !important;
  color: rgba(255, 255, 255, .8) !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background .2s, border-color .2s;
  font-family: inherit;
}
.sh-sarr:hover {
  background: var(--sh-s) !important;
  border-color: var(--sh-s) !important;
  color: #fff !important;
}
.sh-sdots {
  display: flex;
  gap: 6px;
}
.sh-sdot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: rgba(255, 255, 255, .25) !important;
  border: none !important;
  cursor: pointer;
  padding: 0;
  transition:
    background .2s,
    transform .2s,
    width .2s;
}
.sh-sdot--on {
  background: var(--sh-g) !important;
  width: 24px !important;
  border-radius: 5px !important;
  transform: none !important;
}
.sh-hero-right {
  flex-shrink: 0;
  width: 460px;
  position: relative;
}
.sh-hero-img-wrap {
  width: 460px;
  height: 340px;
  border-radius: 22px;
  overflow: hidden;
  box-shadow: 0 32px 80px rgba(0, 0, 0, .4);
  position: relative;
  animation: sh-float 6s ease-in-out infinite;
}
@keyframes sh-float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-12px);
  }
}
.sh-hero-img-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.sh-hero-badge {
  position: absolute;
  background: var(--sh-surf);
  border-radius: 14px;
  padding: 10px 14px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, .2);
  display: flex !important;
  align-items: center;
  gap: 8px;
}
.sh-hero-badge--tl {
  bottom: -18px;
  left: -24px;
}
.sh-hero-badge--br {
  top: -14px;
  right: -18px;
}
.sh-hero-badge strong {
  display: block;
  font-size: 18px !important;
  font-weight: 900 !important;
  color: var(--sh-d) !important;
  line-height: 1;
}
.sh-hero-badge span {
  font-size: 10px !important;
  color: var(--sh-mu) !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: .05em;
}
.sh-stats {
  background: var(--sh-p) !important;
  width: 100% !important;
}
.sh-stats-inner {
  display: flex !important;
  align-items: stretch;
}
.sh-stat {
  flex: 1;
  padding: 26px 16px !important;
  text-align: center;
  border-right: 1px solid rgba(255, 255, 255, .08);
  transition: background .2s;
}
.sh-stat:last-child {
  border-right: none;
}
.sh-stat:hover {
  background: rgba(255, 255, 255, .04);
}
.sh-stat-num {
  display: block;
  font-size: 30px !important;
  font-weight: 900 !important;
  color: var(--sh-g) !important;
  line-height: 1;
  margin-bottom: 4px !important;
}
.sh-stat-label {
  font-size: 11px !important;
  color: rgba(255, 255, 255, .55) !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: .06em;
}
.sh-offers {
  background:
    linear-gradient(
      90deg,
      #fff7e0,
      #ffe8b3) !important;
  border-top: 2px solid rgba(245, 166, 35, .25);
  border-bottom: 2px solid rgba(245, 166, 35, .25);
  width: 100% !important;
}
.sh-offers-inner {
  display: flex !important;
  align-items: center;
  gap: 20px;
  padding-top: 14px !important;
  padding-bottom: 14px !important;
  flex-wrap: wrap;
}
.sh-offers-left {
  display: flex !important;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.sh-offers-pulse {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--sh-g);
  animation: sh-pulse 2s infinite;
  flex-shrink: 0;
}
@keyframes sh-pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.5);
    opacity: .5;
  }
}
.sh-offers-left svg {
  color: var(--sh-p);
}
.sh-offers-left > span {
  font-size: 14px !important;
  font-weight: 800 !important;
  color: var(--sh-d) !important;
  white-space: nowrap;
}
.sh-offers-text {
  flex: 1;
  font-size: 14px !important;
  font-weight: 600 !important;
  color: var(--sh-tx) !important;
}
.sh-offers-text strong {
  color: var(--sh-p) !important;
  font-size: 15px !important;
}
.sh-offers-btn {
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
  background: var(--sh-p) !important;
  color: #fff !important;
  border: none !important;
  border-radius: 100px !important;
  padding: 9px 22px !important;
  font-size: 13px !important;
  font-weight: 800 !important;
  cursor: pointer;
  text-decoration: none !important;
  white-space: nowrap;
  transition: background .2s;
}
.sh-offers-btn:hover {
  background: var(--sh-s) !important;
}
.sh-launch {
  padding: 80px 0 !important;
  background: var(--sh-surf) !important;
  width: 100% !important;
}
.sh-launch-header {
  text-align: center !important;
  margin-bottom: 48px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
}
.sh-launch-eyebrow {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  font-size: 11px !important;
  font-weight: 800 !important;
  letter-spacing: .16em;
  text-transform: uppercase;
  color: var(--sh-p) !important;
  background: var(--sh-li);
  border: 1.5px solid var(--sh-bo);
  padding: 5px 16px;
  border-radius: 100px;
  margin-bottom: 12px;
}
.sh-launch-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--sh-s);
  animation: sh-pulse 2s infinite;
  flex-shrink: 0;
}
.sh-launch-sub {
  font-size: 15px !important;
  color: var(--sh-tl) !important;
  margin-top: 8px !important;
  max-width: 500px;
}
.sh-launch-grid {
  display: grid !important;
  grid-template-columns: 1.2fr 1fr 1fr !important;
  gap: 24px !important;
  width: 100% !important;
}
.sh-launch-card {
  background: var(--sh-bg) !important;
  border: 1.5px solid var(--sh-bo) !important;
  border-radius: 20px !important;
  overflow: hidden;
  position: relative;
  transition:
    transform .25s,
    box-shadow .25s,
    border-color .25s;
}
.sh-launch-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 16px 48px rgba(11, 79, 108, .12) !important;
  border-color: var(--sh-s) !important;
}
.sh-launch-card--featured {
  border-color: var(--sh-p) !important;
  background:
    linear-gradient(
      180deg,
      var(--sh-li) 0%,
      var(--sh-surf) 40%) !important;
}
.sh-launch-card--featured::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background:
    linear-gradient(
      90deg,
      var(--sh-p),
      var(--sh-s));
}
.sh-lc-badge {
  position: absolute;
  top: 14px;
  right: 14px;
  background: var(--sh-p) !important;
  color: #fff !important;
  font-size: 10px !important;
  font-weight: 800 !important;
  letter-spacing: .08em;
  text-transform: uppercase;
  padding: 3px 10px;
  border-radius: 100px;
  z-index: 2;
}
.sh-lc-badge--cyan {
  background: var(--sh-s) !important;
}
.sh-lc-badge--gold {
  background: var(--sh-g) !important;
  color: var(--sh-d) !important;
}
.sh-lc-img {
  height: 180px;
  overflow: hidden;
}
.sh-lc-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform .4s;
}
.sh-launch-card:hover .sh-lc-img img {
  transform: scale(1.06);
}
.sh-lc-body {
  padding: 20px 22px 24px !important;
}
.sh-lc-tag {
  display: inline-block;
  font-size: 10px !important;
  font-weight: 800 !important;
  letter-spacing: .08em;
  text-transform: uppercase;
  color: var(--sh-s) !important;
  margin-bottom: 8px !important;
}
.sh-lc-title {
  font-size: 18px !important;
  font-weight: 900 !important;
  color: var(--sh-d) !important;
  margin-bottom: 8px !important;
  line-height: 1.25 !important;
}
.sh-lc-desc {
  font-size: 13px !important;
  color: var(--sh-tl) !important;
  line-height: 1.65 !important;
  margin-bottom: 14px !important;
}
.sh-lc-meta {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.sh-lc-meta span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px !important;
  font-weight: 700 !important;
  color: var(--sh-mu) !important;
}
.sh-lc-cta {
  display: inline-flex !important;
  align-items: center;
  gap: 4px;
  font-size: 13px !important;
  font-weight: 800 !important;
  color: var(--sh-p) !important;
  text-decoration: none !important;
  border-bottom: 2px solid var(--sh-bo);
  padding-bottom: 2px;
  transition: color .2s, border-color .2s;
}
.sh-lc-cta:hover {
  color: var(--sh-s) !important;
  border-color: var(--sh-s) !important;
}
.sh-explore {
  padding: 80px 0 !important;
  background: var(--sh-bg) !important;
  width: 100% !important;
}
.sh-explore-header {
  display: flex !important;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 36px;
  flex-wrap: wrap;
  gap: 12px;
}
.sh-explore-link {
  font-size: 13px !important;
  font-weight: 800 !important;
  color: var(--sh-p) !important;
  text-decoration: none !important;
  background: var(--sh-li);
  border: 1.5px solid var(--sh-bo);
  border-radius: 100px;
  padding: 8px 18px;
  transition: background .2s, border-color .2s;
}
.sh-explore-link:hover {
  background: var(--sh-p) !important;
  color: #fff !important;
  border-color: var(--sh-p) !important;
}
.sh-explore-grid {
  display: grid !important;
  grid-template-columns: repeat(4, 1fr) !important;
  gap: 18px !important;
  width: 100% !important;
}
.sh-exp-card {
  border-radius: 16px !important;
  overflow: hidden;
  position: relative;
  aspect-ratio: 4/4;
  cursor: pointer;
  box-shadow: 0 4px 18px rgba(11, 79, 108, .08);
  transition: transform .3s, box-shadow .3s;
  text-decoration: none !important;
  display: block;
}
.sh-exp-card:hover {
  transform: translateY(-7px);
  box-shadow: 0 18px 48px rgba(11, 79, 108, .17) !important;
}
.sh-exp-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform .4s;
}
.sh-exp-card:hover img {
  transform: scale(1.07);
}
.sh-exp-overlay {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(
      to top,
      rgba(6, 37, 58, .85) 0%,
      rgba(6, 37, 58, .1) 50%,
      transparent 100%);
  display: flex !important;
  flex-direction: column;
  justify-content: flex-end;
  padding: 16px 14px;
}
.sh-exp-badge {
  display: inline-block;
  background: var(--sh-g) !important;
  color: var(--sh-d) !important;
  font-size: 10px !important;
  font-weight: 800 !important;
  letter-spacing: .06em;
  text-transform: uppercase;
  padding: 3px 10px;
  border-radius: 100px;
  margin-bottom: 6px;
  width: fit-content;
}
.sh-exp-badge--cy {
  background: var(--sh-s) !important;
  color: #fff !important;
}
.sh-exp-badge--gd {
  background: var(--sh-g) !important;
  color: var(--sh-d) !important;
}
.sh-exp-overlay h4 {
  font-size: 14px !important;
  font-weight: 800 !important;
  color: #fff !important;
  margin: 0 !important;
  line-height: 1.3 !important;
}
.sh-upcoming {
  padding: 80px 0 !important;
  background:
    linear-gradient(
      135deg,
      #06253A 0%,
      #0B4F6C 60%,
      #0a6070 100%) !important;
  width: 100% !important;
  position: relative;
  overflow: hidden;
}
.sh-upcoming::before {
  content: "";
  position: absolute;
  width: 500px;
  height: 500px;
  border-radius: 50%;
  background:
    radial-gradient(
      circle,
      rgba(1, 186, 239, .07) 0%,
      transparent 70%);
  top: -200px;
  right: -100px;
  pointer-events: none;
}
.sh-upcoming-header {
  display: flex !important;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 36px;
  flex-wrap: wrap;
  gap: 12px;
  position: relative;
  z-index: 1;
}
.sh-upcoming-all {
  font-size: 13px !important;
  font-weight: 800 !important;
  color: rgba(255, 255, 255, .7) !important;
  text-decoration: none !important;
  background: rgba(255, 255, 255, .08);
  border: 1.5px solid rgba(255, 255, 255, .15);
  border-radius: 100px;
  padding: 8px 18px;
  transition: background .2s;
}
.sh-upcoming-all:hover {
  background: rgba(255, 255, 255, .15) !important;
  color: #fff !important;
}
.sh-upcoming-grid {
  display: grid !important;
  grid-template-columns: repeat(4, 1fr) !important;
  gap: 18px !important;
  width: 100% !important;
  position: relative;
  z-index: 1;
}
.sh-up-card {
  background: rgba(255, 255, 255, .06) !important;
  border: 1.5px solid rgba(255, 255, 255, .12) !important;
  border-radius: 18px !important;
  overflow: hidden;
  cursor: pointer;
  transition:
    background .2s,
    transform .2s,
    border-color .2s;
  text-decoration: none !important;
}
.sh-up-card:hover {
  background: rgba(255, 255, 255, .1) !important;
  border-color: var(--sh-s) !important;
  transform: translateY(-4px);
}
.sh-up-img {
  height: 140px;
  overflow: hidden;
}
.sh-up-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform .4s;
}
.sh-up-card:hover .sh-up-img img {
  transform: scale(1.07);
}
.sh-up-body {
  padding: 14px 16px 18px !important;
}
.sh-up-date {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11px !important;
  font-weight: 700 !important;
  color: var(--sh-g) !important;
  margin-bottom: 6px !important;
  text-transform: uppercase;
  letter-spacing: .05em;
}
.sh-up-title {
  font-size: 14px !important;
  font-weight: 800 !important;
  color: #fff !important;
  line-height: 1.35 !important;
  margin-bottom: 10px !important;
}
.sh-up-loc {
  margin-bottom: 12px;
}
.sh-up-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px !important;
  font-weight: 700 !important;
  padding: 3px 10px;
  border-radius: 100px;
  background: rgba(1, 186, 239, .2) !important;
  color: var(--sh-s) !important;
}
.sh-up-badge--f2f {
  background: rgba(245, 166, 35, .2) !important;
  color: var(--sh-g) !important;
}
.sh-up-btn {
  display: inline-flex !important;
  align-items: center;
  gap: 4px;
  background: var(--sh-g) !important;
  color: var(--sh-d) !important;
  border: none !important;
  border-radius: 100px !important;
  padding: 7px 18px !important;
  font-size: 12px !important;
  font-weight: 800 !important;
  cursor: pointer;
  font-family: inherit;
  text-decoration: none !important;
  transition: background .2s;
}
.sh-up-btn:hover {
  background: #fff !important;
}
.sh-why {
  padding: 80px 0 !important;
  background: var(--sh-surf) !important;
  width: 100% !important;
}
.sh-why-inner {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 64px !important;
  align-items: center !important;
  width: 100% !important;
}
.sh-why-desc {
  font-size: 15px !important;
  color: var(--sh-tl) !important;
  line-height: 1.8 !important;
  margin: 14px 0 28px !important;
  max-width: 440px;
}
.sh-why-cards {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 16px !important;
}
.sh-why-card {
  background: var(--sh-bg) !important;
  border: 1.5px solid var(--sh-bo) !important;
  border-radius: 16px !important;
  padding: 22px 18px !important;
  transition:
    border-color .2s,
    transform .2s,
    box-shadow .2s;
}
.sh-why-card:hover {
  border-color: var(--sh-s) !important;
  transform: translateY(-4px);
  box-shadow: 0 10px 32px rgba(1, 186, 239, .1) !important;
}
.sh-why-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background:
    linear-gradient(
      135deg,
      var(--sh-p),
      var(--sh-s));
  display: flex !important;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin-bottom: 14px;
}
.sh-why-card-title {
  font-size: 15px !important;
  font-weight: 800 !important;
  color: var(--sh-d) !important;
  margin-bottom: 6px !important;
}
.sh-why-card-text {
  font-size: 13px !important;
  color: var(--sh-tl) !important;
  line-height: 1.65 !important;
}
.sh-testi {
  padding: 80px 0 !important;
  background:
    linear-gradient(
      135deg,
      #06253A 0%,
      #0B4F6C 60%,
      #0a6070 100%) !important;
  width: 100% !important;
  position: relative;
  overflow: hidden;
}
.sh-testi::before {
  content: "";
  position: absolute;
  width: 500px;
  height: 500px;
  border-radius: 50%;
  background:
    radial-gradient(
      circle,
      rgba(1, 186, 239, .06) 0%,
      transparent 70%);
  top: -200px;
  right: -120px;
  pointer-events: none;
}
.sh-testi-header {
  text-align: center !important;
  margin-bottom: 48px;
  position: relative;
  z-index: 1;
}
.sh-video-wrap {
  overflow: hidden;
  position: relative;
  z-index: 1;
  border-radius: 16px;
}
.sh-video-track {
  display: flex;
  transition: transform .45s cubic-bezier(.4, 0, .2, 1);
}
.sh-video-item {
  padding: 0 10px;
  flex-shrink: 0;
}
.sh-video-frame {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 12px 36px rgba(0, 0, 0, .3);
  aspect-ratio: 16/9;
}
.sh-video-frame iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
.sh-video-nav {
  display: flex !important;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 32px;
  position: relative;
  z-index: 1;
}
.sh-varr {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: rgba(255, 255, 255, .08) !important;
  border: 1.5px solid rgba(255, 255, 255, .18) !important;
  color: rgba(255, 255, 255, .8) !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background .2s;
  font-family: inherit;
}
.sh-varr:hover:not(:disabled) {
  background: var(--sh-s) !important;
  border-color: var(--sh-s) !important;
  color: #fff !important;
}
.sh-varr:disabled {
  opacity: .3;
  cursor: not-allowed;
}
.sh-vdots {
  display: flex;
  gap: 6px;
}
.sh-vdot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, .25) !important;
  border: none !important;
  cursor: pointer;
  padding: 0;
  transition: background .2s, width .2s;
}
.sh-vdot--on {
  background: var(--sh-g) !important;
  width: 22px !important;
  border-radius: 4px !important;
}
.sh-gallery {
  padding: 80px 0 !important;
  background: var(--sh-surf) !important;
  width: 100% !important;
}
.sh-gallery-header {
  margin-bottom: 40px;
}
.sh-gallery-layout {
  display: grid !important;
  grid-template-columns: 1fr 340px !important;
  gap: 24px !important;
  align-items: start;
  width: 100% !important;
}
.sh-gallery-main {
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  aspect-ratio: 16/10;
  box-shadow: 0 10px 40px rgba(11, 79, 108, .12);
  background: var(--sh-li);
}
.sh-gallery-main img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: opacity .35s;
}
.sh-gallery-main img.sh-gallery-slide {
  opacity: 0;
}
.sh-gallery-label {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px 22px;
  background: linear-gradient(transparent, rgba(6, 37, 58, .7));
  color: #fff !important;
  font-size: 17px !important;
  font-weight: 800 !important;
}
.sh-gallery-side {
  display: flex !important;
  flex-direction: column;
  gap: 16px;
}
.sh-gallery-thumbs {
  display: grid !important;
  grid-template-columns: repeat(3, 1fr) !important;
  gap: 8px !important;
}
.sh-gthumbn {
  border-radius: 10px;
  overflow: hidden;
  aspect-ratio: 1;
  cursor: pointer;
  border: 3px solid transparent;
  transition: border-color .2s, transform .2s;
}
.sh-gthumbn:hover {
  transform: scale(1.04);
}
.sh-gthumbn--on {
  border-color: var(--sh-s) !important;
  box-shadow: 0 0 0 3px rgba(1, 186, 239, .2);
}
.sh-gthumbn img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.sh-gallery-btns {
  display: flex;
  gap: 10px;
}
.sh-galbtn {
  flex: 1;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: var(--sh-p) !important;
  color: #fff !important;
  border: none !important;
  border-radius: 100px !important;
  padding: 11px 16px !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  cursor: pointer;
  font-family: inherit;
  transition: background .2s;
}
.sh-galbtn:hover {
  background: var(--sh-s) !important;
}
.sh-galbtn--outline {
  background: transparent !important;
  color: var(--sh-p) !important;
  border: 1.5px solid var(--sh-bo) !important;
}
.sh-galbtn--outline:hover {
  background: var(--sh-p) !important;
  color: #fff !important;
  border-color: var(--sh-p) !important;
}
.sh-about {
  padding: 80px 0 !important;
  background:
    linear-gradient(
      135deg,
      #06253A 0%,
      #0B4F6C 60%,
      #0a6070 100%) !important;
  width: 100% !important;
  position: relative;
  overflow: hidden;
}
.sh-about::before {
  content: "";
  position: absolute;
  width: 480px;
  height: 480px;
  border-radius: 50%;
  background:
    radial-gradient(
      circle,
      rgba(1, 186, 239, .06) 0%,
      transparent 70%);
  bottom: -160px;
  right: -120px;
  pointer-events: none;
}
.sh-about-inner {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 64px !important;
  align-items: center !important;
  position: relative;
  z-index: 1;
  width: 100% !important;
}
.sh-about-imgwrap {
  position: relative;
}
.sh-about-imgwrap img {
  width: 100% !important;
  height: 420px !important;
  object-fit: cover !important;
  border-radius: 20px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, .3);
  display: block;
}
.sh-about-badge {
  position: absolute;
  bottom: 24px;
  left: -20px;
  background: var(--sh-g);
  border-radius: 14px;
  padding: 14px 18px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, .2);
}
.sh-about-badge-num {
  display: block;
  font-size: 28px !important;
  font-weight: 900 !important;
  color: var(--sh-d) !important;
  line-height: 1;
}
.sh-about-badge-txt {
  font-size: 10px !important;
  font-weight: 800 !important;
  color: var(--sh-d) !important;
  text-transform: uppercase;
  letter-spacing: .06em;
  display: block;
  margin-top: 3px !important;
}
.sh-about-title {
  font-size: clamp(22px, 3vw, 34px) !important;
  font-weight: 900 !important;
  color: #fff !important;
  line-height: 1.2 !important;
  margin: 10px 0 16px !important;
  letter-spacing: -.3px;
}
.sh-about-text {
  font-size: 15px !important;
  color: rgba(255, 255, 255, .7) !important;
  line-height: 1.8 !important;
  margin-bottom: 24px !important;
  max-width: 480px;
}
.sh-about-pts {
  display: flex !important;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 32px !important;
}
.sh-about-pt {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px !important;
  font-weight: 700 !important;
  color: rgba(255, 255, 255, .85) !important;
}
.sh-about-pt::before {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--sh-s);
  flex-shrink: 0;
  display: block;
}
.sh-popup-ov {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .75);
  z-index: 3000;
  display: flex !important;
  align-items: center;
  justify-content: center;
}
.sh-popup-card {
  position: relative;
  max-width: 420px;
  width: 90%;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(0, 0, 0, .35);
}
.sh-popup-card img {
  width: 100%;
  display: block;
}
.sh-popup-x {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, .9) !important;
  border: none !important;
  border-radius: 50%;
  display: flex !important;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--sh-d);
  transition: background .2s;
}
.sh-popup-x:hover {
  background: var(--sh-g) !important;
}
.sh-page section,
.sh-page .sh-stats,
.sh-page .sh-offers,
.sh-page .sh-launch,
.sh-page .sh-explore,
.sh-page .sh-upcoming,
.sh-page .sh-why,
.sh-page .sh-testi,
.sh-page .sh-gallery,
.sh-page .sh-about {
  width: 100% !important;
  float: none !important;
}
.sh-page .sh-container {
  max-width: 1280px !important;
  width: 100% !important;
  margin-left: auto !important;
  margin-right: auto !important;
  padding-left: 48px !important;
  padding-right: 48px !important;
  float: none !important;
  box-sizing: border-box !important;
}
.sh-page .sh-hero-inner,
.sh-page .sh-stats-inner,
.sh-page .sh-explore-grid,
.sh-page .sh-launch-grid,
.sh-page .sh-upcoming-grid,
.sh-page .sh-why-inner,
.sh-page .sh-gallery-layout,
.sh-page .sh-about-inner {
  width: 100% !important;
}
@media (max-width: 1100px) {
  .sh-explore-grid {
    grid-template-columns: repeat(3, 1fr) !important;
  }
  .sh-launch-grid {
    grid-template-columns: repeat(3, 1fr) !important;
  }
  .sh-upcoming-grid {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}
@media (max-width: 900px) {
  .sh-hero-inner {
    flex-direction: column !important;
    gap: 40px !important;
    text-align: center;
  }
  .sh-hero-right {
    width: 100% !important;
  }
  .sh-hero-img-wrap {
    width: 100% !important;
    height: 260px !important;
    animation: none;
  }
  .sh-hero-badge {
    display: none !important;
  }
  .sh-hero-actions {
    justify-content: center !important;
  }
  .sh-slider-ctrl {
    justify-content: center !important;
  }
  .sh-hero-desc {
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .sh-why-inner {
    grid-template-columns: 1fr !important;
    gap: 40px !important;
  }
  .sh-about-inner {
    grid-template-columns: 1fr !important;
    gap: 40px !important;
  }
  .sh-gallery-layout {
    grid-template-columns: 1fr !important;
  }
  .sh-container {
    padding-left: 24px !important;
    padding-right: 24px !important;
  }
  .sh-hero-left {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
  }
  .sh-hero-eyebrow {
    position: relative !important;
    z-index: 1 !important;
    margin-top: 0 !important;
    text-align: center !important;
  }
  .sh-hero-title,
  .sh-hero-desc {
    text-align: center !important;
  }
  .sh-explore-header {
    flex-direction: column !important;
    align-items: center !important;
    text-align: center !important;
  }
  .sh-explore-header > div {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    text-align: center !important;
  }
  .sh-eyebrow {
    justify-content: center !important;
  }
  .sh-upcoming-header {
    flex-direction: column !important;
    align-items: center !important;
    text-align: center !important;
  }
  .sh-about-content {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    text-align: center !important;
  }
  .sh-about-pt {
    justify-content: center !important;
  }
}
@media (max-width: 700px) {
  .sh-explore-grid {
    grid-template-columns: repeat(2, 1fr) !important;
  }
  .sh-launch-grid {
    grid-template-columns: 1fr !important;
  }
  .sh-upcoming-grid {
    grid-template-columns: 1fr !important;
  }
  .sh-why-cards {
    grid-template-columns: 1fr !important;
  }
  .sh-stats-inner {
    flex-wrap: wrap !important;
  }
  .sh-stat {
    flex: 1 1 50% !important;
    border-bottom: 1px solid rgba(255, 255, 255, .06);
  }
  .sh-container {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
  .sh-offers-inner {
    flex-direction: column !important;
    align-items: center !important;
    text-align: center !important;
    gap: 10px !important;
  }
  .sh-offers-left {
    justify-content: center !important;
    width: 100% !important;
  }
  .sh-offers-text {
    text-align: center !important;
    width: 100% !important;
  }
  .sh-offers-btn {
    align-self: center !important;
    margin: 0 auto !important;
  }
  .sh-launch-eyebrow {
    justify-content: center !important;
  }
  .sh-launch-header {
    align-items: center !important;
  }
}
.sh-marquee-section {
  background:
    linear-gradient(
      135deg,
      #06253A 0%,
      #0B4F6C 100%) !important;
  padding: 36px 0 !important;
  width: 100% !important;
  overflow: hidden;
  border-top: 1px solid rgba(255, 255, 255, .08);
  border-bottom: 1px solid rgba(255, 255, 255, .08);
}
.sh-marquee-label {
  text-align: center;
  font-size: 10px !important;
  font-weight: 800 !important;
  text-transform: uppercase;
  letter-spacing: .14em;
  color: rgba(255, 255, 255, 0.35) !important;
  margin-bottom: 14px;
}
.sh-marquee-track-wrap {
  overflow: hidden;
  width: 100%;
  position: relative;
}
.sh-marquee-track-wrap::before,
.sh-marquee-track-wrap::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 80px;
  z-index: 2;
  pointer-events: none;
}
.sh-marquee-track-wrap::before {
  left: 0;
  background:
    linear-gradient(
      to right,
      #06253A,
      transparent);
}
.sh-marquee-track-wrap::after {
  right: 0;
  background:
    linear-gradient(
      to left,
      #0B4F6C,
      transparent);
}
.sh-marquee-track {
  display: flex !important;
  gap: 20px;
  width: max-content;
  animation: sh-marquee 48s linear infinite;
}
.sh-marquee-track:hover {
  animation-play-state: paused;
}
@keyframes sh-marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
.sh-school-chip {
  display: inline-flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: #0B4F6C;
  border: 1.5px solid #e2ecf2;
  border-radius: 16px;
  padding: 18px 24px !important;
  white-space: nowrap;
  flex-shrink: 0;
  transition:
    box-shadow .25s,
    transform .25s,
    border-color .25s;
  cursor: default;
  min-width: 150px;
  max-width: 210px;
  box-shadow: 0 2px 8px rgba(6, 37, 58, .12), 0 0 0 1px rgba(6, 37, 58, .04);
}
.sh-school-chip:hover {
  box-shadow: 0 8px 28px rgba(6, 37, 58, .16) !important;
  border-color: var(--sh-s) !important;
  transform: translateY(-3px);
}
.sh-school-chip img {
  height: 44px !important;
  width: auto !important;
  max-width: 130px !important;
  object-fit: contain !important;
  display: block;
  filter: drop-shadow(0 1px 4px rgba(0, 0, 0, .18));
  transition: filter .25s, transform .25s;
}
.sh-school-chip:hover img {
  filter: drop-shadow(0 2px 8px rgba(11, 79, 108, .28));
  transform: scale(1.04);
}
.sh-school-chip span {
  font-size: 11px !important;
  font-weight: 800 !important;
  color: #ffffff !important;
  text-align: center;
  letter-spacing: .02em;
  line-height: 1.35;
  white-space: normal;
  max-width: 130px;
}
.sh-school-chip:hover span {
  color: var(--sh-p) !important;
}
@media (max-width: 640px) {
  .sh-marquee-track {
    animation-duration: 24s;
  }
  .sh-school-chip {
    font-size: 12px !important;
    padding: 6px 14px !important;
  }
}
.sh-usp {
  padding: 80px 0 !important;
  background: var(--sh-surf) !important;
  width: 100% !important;
}
.sh-usp-header {
  text-align: center !important;
  margin-bottom: 52px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 10px;
}
.sh-usp-eyebrow {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  font-size: 11px !important;
  font-weight: 800 !important;
  letter-spacing: .16em;
  text-transform: uppercase;
  color: var(--sh-p) !important;
  background: var(--sh-li);
  border: 1.5px solid var(--sh-bo);
  padding: 6px 18px;
  border-radius: 100px;
}
.sh-usp-sub {
  font-size: 15px !important;
  color: var(--sh-tl) !important;
  max-width: 540px;
  line-height: 1.7 !important;
}
.sh-usp-grid {
  display: grid !important;
  grid-template-columns: repeat(3, 1fr) !important;
  gap: 20px !important;
  width: 100% !important;
}
.sh-usp-card {
  background: var(--sh-bg) !important;
  border: 1.5px solid var(--sh-bo) !important;
  border-radius: 20px !important;
  padding: 28px 24px 28px !important;
  position: relative;
  overflow: hidden;
  transition:
    transform .25s,
    box-shadow .25s,
    border-color .25s;
}
.sh-usp-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 14px 44px rgba(11, 79, 108, .1) !important;
  border-color: var(--sh-s) !important;
}
.sh-usp-card--featured {
  border-color: var(--sh-p) !important;
  background:
    linear-gradient(
      160deg,
      var(--sh-li) 0%,
      var(--sh-surf) 50%) !important;
}
.sh-usp-card--featured::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background:
    linear-gradient(
      90deg,
      var(--sh-p),
      var(--sh-s));
}
.sh-usp-card--cta {
  background:
    linear-gradient(
      135deg,
      var(--sh-d) 0%,
      var(--sh-p) 100%) !important;
  border-color: transparent !important;
}
.sh-usp-card--cta .sh-usp-card-num {
  color: rgba(255, 255, 255, .2) !important;
}
.sh-usp-card--cta .sh-usp-card-title {
  color: #fff !important;
}
.sh-usp-card--cta .sh-usp-card-text {
  color: rgba(255, 255, 255, .7) !important;
}
.sh-usp-card--cta .sh-usp-tag {
  background: rgba(255, 255, 255, .12) !important;
  color: rgba(255, 255, 255, .75) !important;
}
.sh-usp-card-num {
  font-size: 42px !important;
  font-weight: 900 !important;
  color: rgba(11, 79, 108, .07) !important;
  line-height: 1;
  position: absolute;
  top: 16px;
  right: 20px;
  -webkit-user-select: none;
  user-select: none;
}
.sh-usp-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin-bottom: 18px;
  flex-shrink: 0;
  box-shadow: 0 6px 18px rgba(0, 0, 0, .12);
}
.sh-usp-icon--navy {
  background:
    linear-gradient(
      135deg,
      var(--sh-p),
      #0a6070);
}
.sh-usp-icon--cyan {
  background:
    linear-gradient(
      135deg,
      var(--sh-s),
      #48CAE4);
}
.sh-usp-icon--gold {
  background:
    linear-gradient(
      135deg,
      var(--sh-g),
      #FFD60A);
}
.sh-usp-icon--green {
  background:
    linear-gradient(
      135deg,
      #0B8A4E,
      #2DC653);
}
.sh-usp-icon--purple {
  background:
    linear-gradient(
      135deg,
      #7C3AED,
      #a855f7);
}
.sh-usp-card-title {
  font-size: 17px !important;
  font-weight: 900 !important;
  color: var(--sh-d) !important;
  line-height: 1.25 !important;
  margin-bottom: 10px !important;
}
.sh-usp-card-text {
  font-size: 13px !important;
  color: var(--sh-tl) !important;
  line-height: 1.7 !important;
  margin-bottom: 16px !important;
}
.sh-usp-tags {
  display: flex !important;
  gap: 6px;
  flex-wrap: wrap;
}
.sh-usp-tag {
  display: inline-block;
  font-size: 10px !important;
  font-weight: 800 !important;
  letter-spacing: .07em;
  text-transform: uppercase;
  padding: 3px 10px;
  border-radius: 100px;
  background: var(--sh-li) !important;
  color: var(--sh-p) !important;
  border: 1px solid var(--sh-bo);
}
.sh-usp-tag--g {
  background: rgba(245, 166, 35, .12) !important;
  color: #b37800 !important;
  border-color: rgba(245, 166, 35, .25) !important;
}
@media (max-width: 1000px) {
  .sh-usp-grid {
    grid-template-columns: 1fr 1fr !important;
  }
}
@media (max-width: 640px) {
  .sh-usp-grid {
    grid-template-columns: 1fr !important;
  }
  .sh-usp {
    padding: 56px 0 !important;
  }
  .sh-usp-header {
    margin-bottom: 36px !important;
  }
  .sh-usp-card {
    padding: 22px 18px !important;
  }
}
.sh-page .sh-marquee-section,
.sh-page .sh-usp {
  width: 100% !important;
  float: none !important;
}
/*# sourceMappingURL=home.component.css.map */
